import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-628eac5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "type-container"
}
const _hoisted_3 = { class: "type" }

import {onMounted, onUnmounted, PropType, Ref, ref} from "vue";
import {CursorHelper} from "@/lib/common/helpers/CursorHelper";
import {SSegmentedTarget} from "@/store/Spatial2DAnnotation/model/SSegmentedTarget";
import {S2DSegment} from "@/store/Spatial2DAnnotation/model/S2DSegment";


export default /*#__PURE__*/_defineComponent({
  name: 'DotAnnotation',
  props: {
  dotAnnotation: {
    type: Object as PropType<S2DSegment>,
    required: true,
  },
  parentTarget: {
    type: Object as PropType<SSegmentedTarget>,
    required: true,
  },
  parentOverlayRef: {
    type: Object as PropType<Ref<HTMLElement>>,
    required: true,
  },
  isFirst: Boolean
},
  emits: ["onTrueMouseover", "onTrueMouseleave"],
  setup(__props, { expose, emit: emits }) {

const props = __props

_useCssVars(_ctx => ({
  "597a7696": (adjustedTop),
  "545eda34": (adjustedLeft),
  "3998083f": (colorCode.value)
}))




const colorCode = ref(props.dotAnnotation.colorCode);

const adjustedTop = "calc(" + props.dotAnnotation.top + "% - 4px)",
    adjustedLeft = "calc(" + props.dotAnnotation.left+ "% - 4px)";

// ------------------------------
//  Annotation hover handling
// ------------------------------

const dotAnnotationRef = ref();
let cursorHelperEventInstanceId: string;

const isTrueMouseHovering = ref(false);



onMounted(() =>
{
  cursorHelperEventInstanceId = CursorHelper.watchTrueMouseHover(
      dotAnnotationRef.value,
      () => {
        isTrueMouseHovering.value = true;
        emits("onTrueMouseover", props.dotAnnotation)
  }, () => {
        isTrueMouseHovering.value = false;
        emits("onTrueMouseleave", props.dotAnnotation)
  })
})

onUnmounted(() => {
  emits("onTrueMouseleave", props.dotAnnotation);
  CursorHelper.unwatchTrueMouseHover(cursorHelperEventInstanceId);
})

// ------------------------------
//  Expose
// ------------------------------

expose({
  dotAnnotationRef
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('dot-annotation-container ' + (__props.isFirst ? 'first-annotation' : '') + ' ' + (__props.parentTarget.isCurrent ? 'current' : '') + ' ' + (__props.parentTarget.isCompleted ? 'completed' : ''))
  }, [
    _createElementVNode("div", {
      id: 'dot-annotation-' + __props.dotAnnotation.instanceId + '-' + __props.dotAnnotation.type,
      class: _normalizeClass('dot-annotation ' + (isTrueMouseHovering.value ? 'hovered' : '')),
      ref_key: "dotAnnotationRef",
      ref: dotAnnotationRef
    }, null, 10, _hoisted_1),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.dotAnnotation.type), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})